module.exports = __webpack_public_path__ + "static/media/progenitor_daughter_death.4bf204c3.gif";